import React from 'react';
import {useDispatch} from 'react-redux';
import {errorMessage, flashMessage} from 'shared/actions/notifications';
import Loading from 'shared/components/loading';
import Button from 'src/components/button';
import {useBoolean} from 'src/hooks/useBoolean';
import EducatorVerificationService, {
  PendingEducator,
} from 'src/services/EducatorVerificationService';

interface VerificationButtonProps {
  educator: PendingEducator;
  buttonSize: 'tiny' | 'small' | 'medium' | 'large';
}

export default function VerifyButton(props: VerificationButtonProps) {
  const loading = useBoolean(false);
  const verified = useBoolean(false);
  const dispatch = useDispatch();

  const onClickHandler = async () => {
    try {
      loading.setTrue();
      await EducatorVerificationService.verify(props.educator._id);
      dispatch(flashMessage('User has been successfully verified!'));
      verified.setTrue();
    } catch (err) {
      console.log(err);
      dispatch(errorMessage());
    } finally {
      loading.setFalse();
    }
  };

  if (loading.value) {
    return (
      <Button size={props.buttonSize}>
        <Loading />
      </Button>
    );
  }

  return (
    <Button disabled={verified.value} size={props.buttonSize} onClick={onClickHandler}>
      {verified.value ? 'Verified' : 'Verify'}
    </Button>
  );
}

VerifyButton.defaultProps = {
  buttonSize: 'small',
};
